import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ConfirmMail from "../views/dashboard/auth/confirm-mail";
import LockScreen from "../views/dashboard/auth/lock-screen";
import Recoverpw from "../templates/Login/recoverpw";
import SignIn from "../templates/Login/sign-in";
import SignUp from "../views/dashboard/auth/sign-up";
import ResetPassword from "../templates/Login/ResetPassword";
import Error404 from "../views/dashboard/errors/error404";

const PublicRoutes = () => {
  return (
    <Routes>
      {/* auth */}
      <Route path="/auth/confirm-mail" element={<ConfirmMail />} />
      <Route path="/auth/lock-screen" element={<LockScreen />} />
      <Route path="/forgetPassword" element={<Recoverpw />} />
      <Route path="/ResetPassword" element={<ResetPassword />} />
      <Route path="/auth/sign-in" element={<SignIn />} />
      <Route path="/auth/sign-up" element={<SignUp />} />

      {/* 👇 Default redirect when not authenticated */}
      <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>
  );
};

export default PublicRoutes;
